import React, { useState, useEffect } from "react";
import "./App.css";
import Header from './components/Header';
import Footer from './components/Footer';
import VideoPlayer from './components/VideoPlayer';
import DisclaimerModal from './components/DisclaimerModal';

const App = () => {
  // Resources data
  const resources = [
    {
      name: "Evidencer.io",
      url: "https://evidencer.io/",
      image: "/images/evidencer-io.png",
      description: "Evidence-based protocols for decentralized applications"
    },
    {
      name: "Web3 Identity",
      url: "https://keypairs.freeweb3.com",
      image: "/images/Screenshot_20241212_224540.png",
      description: "Secure identity management for blockchain users"
    },
    {
      name: "Public Upload",
      url: "https://upload.freeweb3.com",
      image: "/images/Screenshot_20241211_232432.png",
      description: "Upload content to decentralized storage networks"
    },
    {
      name: "Encrypted Upload",
      url: "https://upload-encrypted.freeweb3.com/",
      image: "/images/2025-sites-07-600w.png",
      description: "Encrypted content storage on decentralized networks"
    },

  ];

  // Video data
  const videos = [
    {
      title: "Web3 Evidencer Introduction",
      src: "/videos/2025-640x360-02-in-the-fast-paced-paramount-2.mp4",
      type: "video/mp4",
      poster: "/images/2025-TILESX-01-800.png",
      description: "An introduction to Web3 legal frameworks and their applications"
    },
    {
      title: "Decentralized Identity",
      src: "/videos/2025-640x360-31-step-1-setup-identity.mp4",
      type: "video/mp4",
      poster: "/images/2025-TILESX-06-800.png",
      description: "How decentralized identity works in Web3 legal frameworks"
    },
        {
      title: "Web3 Intro - ELI5 Version",
      src: "/videos/2025-640x360-16-welcome-the-world-treasure-1.mp4",
      type: "video/mp4",
      poster: "/images/2025-TILESX-05-800.png",
      description: "An introduction to Web3 legal frameworks and their applications"
    },
    {
      title: "Basic Evidencer Walkthrough",
      src: "/videos/2025-640x360-21-three-main-steps.mp4",
      type: "video/mp4",
      poster: "/images/2025-TILESX-07-800.png",
      description: "How decentralized identity works in Web3 legal frameworks"
    }
  ];

  // Theme state management
  const [theme, setTheme] = useState('light');

  // Disclaimer modal state
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);

  useEffect(() => {
    // Check for user's preferred theme
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setTheme(savedTheme);
      document.body.setAttribute('data-theme', savedTheme);
    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
      document.body.setAttribute('data-theme', 'dark');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    document.body.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  // No longer needed as we're using the VideoPlayer component

  return (
    <div className="app">
      <Header toggleTheme={toggleTheme} />

      <main className="main-content">
        <h1 className="section-title">FreeWeb3 Application Hub</h1>
        <p className="section-description">
          Explore our suite of decentralized applications built on Web3 technology, designed to bridge legal frameworks with blockchain innovation.
        </p>

        {/* Videos */}
        <section className="videos-section">
          <h2 className="section-title">Featured Videos</h2>
          <div className="videos-grid">
            {videos.map((video, index) => (
              <div key={index} className="video-item">
                <h3 className="video-title-external">{video.title}</h3>
                <VideoPlayer
                  src={video.src}
                  poster={video.poster}
                  type={video.type}
                />
              </div>
            ))}
          </div>
        </section>

        {/* Resources Grid */}
        <section className="grid">
          <h2 className="section-title">Applications</h2>
          <div className="grid-container">
            {resources.map((resource, index) => (
              <div className="resource-card" key={index}>
                <a
                  href={resource.url}
                  target="_blank"
                  rel="noreferrer"
                  className="resource-link"
                >
                  <div className="img-container">
                    <img src={resource.image} alt={resource.name} />
                    <div className="img-overlay">
                      <span className="img-label">{resource.name}</span>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </section>
      </main>

      <Footer onOpenDisclaimer={() => setDisclaimerOpen(true)} />

      {/* Disclaimer Modal */}
      <DisclaimerModal open={disclaimerOpen} onClose={() => setDisclaimerOpen(false)} />
    </div>
  );
};

export default App;